import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import Header from "../components/Header";

function Weehawken() {
  const cityName = "Weehawken";
  const state = "NJ";
  const fullCityName = `${cityName}, ${state}`;
  
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog13.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Luxury Transportation Services in {fullCityName}
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>/</span>
            <span className="text-logo-green">{fullCityName}</span>
          </div>
        </div>
      </div>
    </section>

    {/* Premium Transportation Services Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt={`Premium Transportation in ${fullCityName}`}
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Premium Transportation Services in {fullCityName}
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Welcome to your top-rated transportation provider in {cityName} and North New Jersey. Whether you need airport transfer, corporate travel, or event shuttle, our luxury fleet and professional chauffeurs deliver unmatched reliability and comfort.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              From sleek sedans to spacious coaches, every ride is tailored to {cityName} locals and visitors alike. We serve metro New York destinations, including Newark, Manhattan, Brooklyn, and surrounding areas.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Why Choose Us Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="md:order-1 order-2">
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Why Choose Us in {cityName} For Transportation?
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              When choosing us in {cityName}, you're choosing proven excellence in local transport. Our licensed chauffeurs know traffic patterns, shortcuts, and customer service. That's why residents rely on us for truly professional <strong>ground transportation</strong>.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              We offer transparent pricing, 24/7 availability, and a fleet ranging from executive limos to party buses. Whether you're arriving at Newark Airport or heading to a wedding, we make every ride seamless.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
          <div className="md:order-2 order-1">
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt={`Why Choose Us in ${fullCityName}`}
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Airport Transfer Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt="Airport Transfer"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Airport Transfer
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Our <strong>Airport Transfer</strong> service in {cityName} ensures you travel to and from Newark Liberty International Airport (EWR), John F. Kennedy International Airport (JFK), and LaGuardia Airport (LGA) without stress. Your chauffeur tracks flights and adjusts pick-up times to compensate for delays or early arrivals.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              Whether it's business or leisure travel, our airport transfer service offers door-to-door convenience, ample luggage space, clean sedans or SUVs, and flat-rate pricing that's ideal for families and frequent flyers across New Jersey.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Concerts and Festivals Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="md:order-1 order-2">
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Concerts and Festivals
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Heading to local shows or major festivals? Our <strong>Concerts and Festivals transportation</strong> service delivers prompt pick-ups in {cityName}, timely arrival at venues, and comfortable returns home.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              We provide SUVs, sprinters, and party vehicles, ensuring your group enjoys tailgating or VIP access effortlessly. Trust our experienced drivers to navigate traffic and drop-off zones so you can focus on the fun.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
          <div className="md:order-2 order-1">
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt="Concerts and Festivals"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Corporate Limo Service Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt="Corporate Limo Service"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Corporate Limo Service
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Experience premium <strong>Corporate Limo Service</strong> in {cityName} for board meetings, airport rides, and executive travel. Our impeccably dressed chauffeurs provide professional, discreet service while you focus on business.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              Ideal for visiting clients or local professionals, our vehicles include luxury sedans and black SUVs. Enjoy 24/7 availability, easy invoicing, and seamless transfers across Greater New York and New Jersey.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Group Transportation Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="md:order-1 order-2">
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Group Transportation
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Our <strong>Group Transportation</strong> service in {cityName} is perfect for church groups, conferences, or family outings across New Jersey. We provide vans, coaches, and sprinters with Wi-Fi, climate control, and courteous service.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              Coordinated with precision, every group booking includes itinerary planning, multi-stop logistics, and flat group rates. Whether you head to Manhattan, Brooklyn, or coastal areas, we get everyone there in comfort.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
          <div className="md:order-2 order-1">
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt="Group Transportation"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Hourly Service Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt="Hourly Service"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Hourly Service
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Need flexible, chauffeur-driven transport in {cityName}? Our <strong>Hourly Service</strong> lets you reserve a vehicle by the hour, ideal for errands, meetings, or town-to-town local travel.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              No surprise fees, unlimited stops, and professional drivers at your disposal. Enjoy top-tier hourly service for shopping, sightseeing, appointments, or wine tasting in New Jersey.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Party Bus Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="md:order-1 order-2">
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Party Bus {cityName}
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Celebrate with ease using our <strong>Party Bus {cityName}</strong> service. Perfect for birthdays, weddings, brewery tours, or game nights, our buses seat 20+, feature advanced sound systems, lighting, and beverage space.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              Fully compliant with New Jersey limo regulations, our chauffeurs take care of logistics while you enjoy the ride. Perfect for groups roaming New York's nightlife or attending local festivals.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
          <div className="md:order-2 order-1">
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt="Party Bus"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Leisure Transportation Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt="Leisure Transportation"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Leisure Transportation
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Explore New Jersey in style with our Leisure Transportation services departing from {cityName}, wine tours, beach escapes, or scenic drives in North New Jersey.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              Custom itineraries adapt to your interests, with stops at restaurants, attractions, and scenic views. Relax in upscale vehicles with a local chauffeur guiding the way throughout your journey.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Prom Night Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="md:order-1 order-2">
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Prom Night
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Make prom night unforgettable with our <strong>Prom Night Transportation</strong> in {cityName}. Arrive in elegance with stretch limos or luxury SUVs, complete with professional red carpet service and hassle-free group boarding.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              Safety is our priority, chauffeurs are background-checked, vehicles are inspected, and fixed pricing keeps parents worry-free. Trust us to deliver both style and peace of mind.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
          <div className="md:order-2 order-1">
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt="Prom Night"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Sporting Events Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt="Sporting Events"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Sporting Events
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Going to a Yankees game, Giants match, or college <strong>sporting event?</strong> Our Sporting Events transport offers drop-off near stadiums and coordinated return rides to {cityName} or surrounding areas.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              Choose private SUVs or party buses for fans on the move. We streamline parking logistics, traffic exits, and group pickup zones so you focus on cheering not driving.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Wedding Transportation Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="md:order-1 order-2">
            <h2 className="text-2xl font-bold text-black mb-4 leading-tight">
              Wedding Transportation
            </h2>
            <p className="text-lg mb-4 text-gray-900 leading-relaxed">
              Count on our <strong>Wedding Transportation</strong> services in {cityName} for seamless travel on your big day. From bridal party limos to guest shuttles, we handle everything from timeline coordination to venue logistics.
            </p>
            <p className="text-lg mb-6 text-gray-900 leading-relaxed">
              Our team adapts to last-minute changes, multiple pickup locations, and tight schedules. Punctual, polished, and personable and our service adds elegance and reliability to your wedding plans.
            </p>
            <div className="flex gap-4">
              <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
                Book Now
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
                Call Now
              </a>
            </div>
          </div>
          <div className="md:order-2 order-1">
            <img 
              src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" 
              alt="Wedding Transportation"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Let's Connect With Us Section */}
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-black mb-4 leading-tight">
          Let's Connect With Us
        </h2>
        <p className="text-lg mb-8 text-gray-900 leading-relaxed max-w-3xl mx-auto">
          Whether you're booking an <strong>airport transfer, wedding ride,</strong> or <strong>party bus</strong> in {cityName}, our team makes reservations effortless. Choose online booking, a quick phone call, or email inquiry, available 24/7.
        </p>
        <p className="text-lg mb-8 text-gray-900 leading-relaxed max-w-3xl mx-auto">
          Tell us your date, destination, or event type, and we'll suggest the right vehicle, prepare a quote, and confirm details. Book now for premium New Jersey transportation and travel with confidence.
        </p>
        <div className="flex gap-4 justify-center">
          <a href="/booknow" className="bg-black text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors">
            Book Now
          </a>
          <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100 transition-colors">
            Call Now
          </a>
        </div>
      </div>
    </section>

    <FAQ/>
    <Footer/>
    </>
  );
}

export default Weehawken;

